export default __webpack_public_path__ + "52a1788fd07d99608dcccab5ffe6478f.png";